import { render, staticRenderFns } from "./MonitriipNotice.vue?vue&type=template&id=267ccd3a&"
import script from "./MonitriipNotice.vue?vue&type=script&lang=js&"
export * from "./MonitriipNotice.vue?vue&type=script&lang=js&"
import style0 from "./MonitriipNotice.vue?vue&type=style&index=0&id=267ccd3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports